export const Constants = {

    ID_CATEGORIA_CICLO_BASICO: 1,
    TAMANHO_LIMITE_TITULO_TOPICO: 34,
    INIT: 70,
    LOADING: 71,
    ERROR: 72,
    LOADED: 73
  }
  
  export default Constants
  